import { API_URL } from '../../../components/config/BaseUrl';

export const GET_USER_WORKGROUP_URL = `${API_URL}/web/usersip`;
export const GET_USERS_IN_WORKGROUP_URL = `${API_URL}/wificall/getWorkgroupList`;
